import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const chatService = {
    fetchChatMessages,
    sendChatMessage,
    reportChatMessage
};

function fetchChatMessages(classId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.chatmessage.fetchChat}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function sendChatMessage(msg) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.chatmessage.sendChat, msg, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function reportChatMessage(reportMsg) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.chatmonitoring.reportChat, reportMsg, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}